import React, { useEffect, useRef } from 'react';

// Campo de estrelas 2D (proposta aprovada): canvas absoluta, pontos lavanda
// determinísticos + estrela-guia dourada. Sem three.js, sem rAF — redraw no resize.
export const StarField: React.FC<{ className?: string }> = ({ className }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const drawStar = (x: number, y: number, r: number, o: number) => {
      ctx.beginPath();
      ctx.arc(x, y, r, 0, 7);
      ctx.fillStyle = `rgba(217,200,255,${o})`;
      ctx.fill();
    };

    const draw = () => {
      const dpr = window.devicePixelRatio || 1;
      const w = canvas.clientWidth;
      const h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.scale(dpr, dpr);
      ctx.clearRect(0, 0, w, h);

      let seedN = 7;
      const rnd = () => {
        seedN = (seedN * 9301 + 49297) % 233280;
        return seedN / 233280;
      };

      for (let i = 0; i < 80; i++) {
        drawStar(rnd() * w, rnd() * h, rnd() * 1.2 + 0.3, rnd() * 0.55 + 0.12);
      }

      // Estrela-guia dourada
      const sx = w * 0.72;
      const sy = h * 0.3;
      ctx.beginPath();
      ctx.arc(sx, sy, 1.8, 0, 7);
      ctx.fillStyle = 'rgba(232,200,122,.95)';
      ctx.fill();
      ctx.beginPath();
      ctx.arc(sx, sy, 6, 0, 7);
      ctx.strokeStyle = 'rgba(232,200,122,.28)';
      ctx.stroke();
    };

    draw();
    window.addEventListener('resize', draw, { passive: true });
    return () => window.removeEventListener('resize', draw);
  }, []);

  return <canvas ref={canvasRef} aria-hidden="true" className={className} />;
};